import React, { FunctionComponent } from 'react'
import { DesktopItemList } from './desktop-item-list'
import NavigationAction from '../shared/navigation-action'
import { NavigationCta, NavigationItem } from '../types'

interface DesktopNavigationMenuProps {
  items: NavigationItem[]
  ctaButton: NavigationCta
}

const DesktopNavigationMenu: FunctionComponent<DesktopNavigationMenuProps> = ({ items, ctaButton }) => {
  return (
    <>
      <DesktopItemList items={items} />
      <NavigationAction {...ctaButton} />
    </>
  )
}

export default DesktopNavigationMenu
